module.exports = __webpack_public_path__ + "static/media/Risorsa 005.8d054238.svg";